<template>
  <el-form :model="form" ref="form" label-position="top">
    <el-row>
      <el-col :span="12">
        <el-form-item label="发呆时间" prop="qidleseconds">
          <el-input v-model="form.qidleseconds"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="睡眠时间" prop="pauseseconds">
          <el-input v-model="form.pauseseconds"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="阈值" prop="threshold">
          <el-input-number v-model="form.threshold"></el-input-number>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="是否自动创建队列" prop="autocreate">
          <el-switch
            v-model="form.autocreate"
            active-text="开"
            inactive-text="关">
          </el-switch>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
  import rApi from "@/api/senior/seniorconf";
let datafault = {
};
export default {
  components: { rApi },
  props: {
    uuid:""
  },
  data() {
    return {
      form:{
        qidleseconds:60,
        pauseseconds:"30, 60",
        threshold:50000,
        autocreate:true

      }
    };
  },
  mounted() {
    if(this.uuid){
      rApi.getCsSenior(this.uuid).then(resp=>{
        var _form = JSON.parse(resp.data);
        this.form.qidleseconds = _form.qidleseconds?_form.qidleseconds:this.form.qidleseconds;
        this.form.pauseseconds = _form.pauseseconds?_form.pauseseconds:this.form.pauseseconds;
        this.form.threshold = _form.threshold?_form.threshold:this.form.threshold;
        this.form.autocreate = _form.autocreate||_form.autocreate===false?_form.autocreate:this.form.autocreate;
      });
    }
  },
  methods: {
    save(){
      if(this.uuid){
        rApi.doSaveForCsSenior(this.uuid,JSON.stringify(this.form)).then(()=>this.$message.success("操作成功！"));
      }
      return this.form;
    }
  }
};
</script>
<style scoped>
</style>